// lib/managers/dataManager/google/types/const.ts

// Google API base URLs
export const gmailApiUrl = "https://gmail.googleapis.com/gmail/v1";
export const gmailBatchApiUrl = "https://gmail.googleapis.com/batch";
export const calendarApiUrl = "https://www.googleapis.com/calendar/v3";
export const driveApiUrl = "https://www.googleapis.com/drive/v3";
export const peopleApiUrl = "https://people.googleapis.com/v1";

// Mapping des dossiers Outlook vers les labels Gmail
export const mapFolderToLabel: { [key: string]: string } = {
    inbox: "INBOX",
    sentitems: "SENT",
    // 'draft'         : 'DRAFT',
    junkemail: "SPAM",
    deleteditems: "TRASH",
};
